import type { TextKey } from "../i18n/es.ts";

export type DrawingTool = "subBasin" | "aquifer" | "outletPoint";

/** Text keys (not literals) — resolved with useT() when shown, see SubBasinMap.tsx. */
export const TOOL_LABEL: Record<DrawingTool, TextKey> = {
  subBasin: "drawing.subBasin",
  aquifer: "drawing.aquifer",
  outletPoint: "drawing.outletPoint",
};

/** true if the tool draws a single-click point; false if it draws a polygon (several clicks + "Finish"). */
export function isPointTool(tool: DrawingTool): boolean {
  return tool === "outletPoint";
}
